import { RevealText } from "src/components/animation/reveal-text"
import Button from "src/components/button"
import corporatePointData from "src/data/corporate-point-data.json"
import CardSection from "./components/card-section"

function UmkmAndRetail(){
    return(<div className="pt-[139px]">
        <div id="headline" className="relative flex flex-col justify-center items-center mx-[24px] sm:mx-[80px] md:mx-[120px] xl:mx-[240px] h-[480px] md:h-[560px] lg:h-full my-[0px] lg:my-[128px] gap-[16px]">
            <div className="text-[32px] lg:text-[48px] font-bold leading-[36px] lg:leading-[50px]">
                <RevealText>
                     <span className="font-lora font-medium italic">Empowering</span> UMKM & Retail <br/>with Smart Digital Solutions.
                </RevealText>
            </div>
            <RevealText className="w-full lg:w-1/2 text-grey">Automate your customer service, scale your online presence, and manage your growing business from a single, intuitive dashboard. Built for modern F&B and Retail teams.</RevealText>
            <div className="flex flex-row gap-[16px]">
                <Button to={"/contact-us"} onClick={() => {}} color="yellow">Contact Sales</Button>
            </div>
            <img className="absolute right-0 top-0 animate-float-enhanced-a" src="/icons/star-1.svg"></img>
            <img className="absolute left-0 bottom-0 animate-float-enhanced-b" src="/icons/star-2.svg"></img>
        </div>
        <hr/>
        <div className="py-[96px] px-[48px] mx-[24px] flex flex-col bg-black text-white rounded-[16px] justify-center items-center text-left gap-[32px]">
            <div className="text-center">
                <p className="text-[24px] lg:text-[32px] font-semibold ">Growing a Business Shouldn't Mean <span className="font-lora font-medium italic">Losing Control</span></p>
                <p>Managing high volumes of inquiries with a small team is exhausting. <br/>We help you eliminate the friction</p>
            </div>
            <div className="grid grid-cols-1 text-left xl:w-1/3 py-[24px]">
                <div className="w-full flex flex-col md:flex-row gap-[8px] py-[16px]">
                    <div className="w-1/12">
                        <img className="" src="/icons/leaves-yellow.svg"></img>
                    </div>
                    <p className="md:w-6/12 font-lora">Overwhelming Chat Volumes</p>
                    <p className="md:w-5/12">Struggling to answer WhatsApp and Instagram DMs fast enough during peak hours.</p>
                </div>
                <hr cl></hr>
                <div className="w-full flex flex-col md:flex-row gap-[8px] py-[16px]">
                    <div className="w-1/12">
                        <img className="w=fit" src="/icons/leaves-yellow.svg"></img>
                    </div>
                    <p className="md:w-6/12 font-lora">Manual Processes</p>
                    <p className="md:w-5/12">Wasting time manually taking orders, answering FAQs, and tracking down customer details.</p>
                </div>
                <hr></hr>
                <div className="w-full flex flex-col md:flex-row gap-[8px] py-[16px]">
                    <div className="w-1/12">
                        <img className="w=fit" src="/icons/leaves-yellow.svg"></img>
                    </div>
                    <p className="md:w-6/12 font-lora">High Tech Barriers</p>
                    <p className="md:w-5/12">Most enterprise-level tools are too expensive and overly complicated for growing teams.</p>
                </div>
            </div>
        </div>
        <div className="my-[96px] flex flex-col justify-center items-center gap-[32px]">
            <div>
                <p className="text-[32px] font-semibold">Everything You <span className="font-lora font-medium italic">Need to Scale</span> Smartly</p>
                <p className="text-grey">We combine robust web development with our flagship product, Orqestra, to streamline your operations.</p>
            </div>
            <CardSection/>
        </div>
        <hr/>
        <div className="px-[16px] md:px-[0px] relative py-[128px] flex flex-col gap-[24px] justify-center items-center text-center">
            <h1 className="text-[32px] lg:text-[48px] font-bold leading-[36px] lg:leading-[50px]">Ready to upgrade <span className="font-lora font-medium italic">Upgrade</span><br/>your business operations?</h1>
            <Button to={"/contact-us"} onClick={() => {}} color={"black"}>Contact Sales</Button>
            <img className="absolute right-4 md:right-16 top-10 w-8 md:w-auto animate-float-enhanced-a opacity-50 md:opacity-100" src="/icons/star-1.svg" alt="" />
            <img className="absolute left-4 md:left-16 bottom-10 md:bottom-auto md:top-20 w-6 md:w-auto animate-float-enhanced-b opacity-50 md:opacity-100" src="/icons/star-2.svg" alt="" />
        </div>
    </div>)
}

export default UmkmAndRetail